// export const BASE_URL = "https://demo.dev9server.com/Cevaheer/api"
// export const IMAGE_BASE_URL = 'https://demo.dev9server.com/Cevaheer/storage/app/public/'
// export const base_url = 'https://demo.dev9server.com/cevaheer-latest-front'
// export const BACKEND_BASE_URL ="https://demo.dev9server.com:4568"

// export const BASE_URL = "https://www.cevaheer.com/cevaheer/api"
// export const IMAGE_BASE_URL = 'https://d28q6ef240x938.cloudfront.net/'
// export const base_url = 'https://www.cevaheer.com/'// live
// export const BACKEND_BASE_URL = 'https://www.cevaheer.com:4568'



// export const BASE_URL = "https://www.cevaheer.com/CR11/api"
// export const IMAGE_BASE_URL = 'https://d28q6ef240x938.cloudfront.net/'
// export const base_url = 'https://www.cevaheer.com/'// live
// export const BACKEND_BASE_URL = 'https://www.cevaheer.com:8565'

export const BASE_URL = "https://staging.cevaheer.com/cevaheer/api"
export const IMAGE_BASE_URL = 'https://d1s8trzsjz3ep4.cloudfront.net/' // staging
export const base_url = 'https://staging.cevaheer.com/'// live
export const BACKEND_BASE_URL = 'https://staging.cevaheer.com:4568'

// local 
// export const BASE_URL = "http://localhost/cevaheer/api"
// export const IMAGE_BASE_URL = 'https://d1s8trzsjz3ep4.cloudfront.net/' // staging
// export const base_url = 'http://localhost/cevaheer/'// local
// export const BACKEND_BASE_URL = 'http://localhost:4568'

// export const IMAGE_BASE_URL = 'http://localhost/Cevaheer/storage/app/public/' 
// export const CERTIFICATE_BASE_URL = 'https://d28q6ef240x938.cloudfront.net/' // live
export const CERTIFICATE_BASE_URL = 'https://d1s8trzsjz3ep4.cloudfront.net/'   // stgaging

export const TOKEN = localStorage.getItem('isAuthenticated')
export const url = process.env.PUBLIC_URL;
// export const base_url = 'https://localhost:3000/cevaheer-latest-front'
export const hrdurl = "https://my.hrdantwerp.com/?record_number="
export const giaurl = "https://www.gia.edu/report-check?reportno="
export const currency = "$"
export const AddressApi1 = 'https://ipwho.is/'
export const AddressApi2 = 'https://ipapi.co/json/'
// export const BACKEND_BASE_URL ="http://localhost:4568"
export const postPerPage = 20
export const SC = 1